
export default function MapMainDirective() {
    return {
        template: require('./map-main.html'),
        controller: "MapMainController",
        transclude: true,
        restrict: 'E'
    };
}
